import { useContext } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import { connect } from 'react-redux'
import { getPrioritySupportContact } from 'selectors/supportContactSelector'

import BodyText from 'LuxKit/Typography/BodyText'
import LinePhoneIcon from 'LuxKit/Icons/line/LinePhoneIcon'
import TextButton from 'LuxKit/Button/TextButton'
import ContactContext, { ContactProvider } from 'contexts/contactContext'

const Root = styled.div`
  border-radius: ${props => props.theme.borderRadius.S};
  padding: ${rem(12)} ${rem(20)};
  border: 1px solid ${props => props.theme.palette.neutral.default.six};
  background-color: ${props => props.theme.palette.neutral.default.seven};
`

const WarningMessage = styled(BodyText)`
  margin-top: ${rem(4)};
`

const CallNowButton = styled(TextButton)`
  margin-top: ${rem(16)};
`

interface Props {
  className?: string
  currentPriorityNumber: App.GeoContacts
  error: {
    status: number
    message: string
  }
}

function RebookingError(props: Props) {
  const { className, currentPriorityNumber, error } = props
  const intl = useIntl()
  const contactNumber = useContext(ContactContext)

  const duplicateBookingMessage = intl.formatMessage({
    id: '1Y-l3N1C6n2F6XJ7R1wo',
    defaultMessage: 'If you wish to modify your booking or add more flights with your credit, please contact our customer support team.',
    description: 'Error description shown when a duplicate flight rebooking is attempted',
  })
  const invalidInputMessage = intl.formatMessage({
    id: 'UvswslJ0dSNtWArJH1fZ',
    defaultMessage: 'Please reconfirm your details and try again, or contact our flight support team for assistance.',
    description: 'Error description shown when flight rebooking details are invalid',
  })
  const description = error.status === 409 ? duplicateBookingMessage : invalidInputMessage

  return (
    <Root className={className}>
      <BodyText variant="medium" weight="bold">
        {error.message}
      </BodyText>
      <WarningMessage variant="small">
        {description}
      </WarningMessage>
      <ContactProvider contact={currentPriorityNumber}>
        <CallNowButton
          kind="secondary"
          startIcon={<LinePhoneIcon colour="primary" />}
          href={`tel:${contactNumber.local.number}`}
        >
          {contactNumber.local.humanReadable}
        </CallNowButton>
      </ContactProvider>
    </Root>
  )
}

function mapStateToProps(state: App.State) {
  return {
    currentPriorityNumber: getPrioritySupportContact(state),
  }
}

export default connect(mapStateToProps)(RebookingError)
